import React from 'react';

import { ApiErrorPage } from '@britishcouncil/react-solas-ors3';

export const Error404 = () => (
  <ApiErrorPage errorMessage="The page you where looking for doesn't exist. You may have mistyped the address or the page may have moved." />
);
